<div class="contentBox">
    <nav class="bg-yeminus-color">
        <div class="nav-wrapper">
            <img src="assets/img/logoyeminus.jpg" class="responsive-img nav-wrapper">
        </div>
    </nav>
    <div class="content col-md-6">
        <div class="cajaPrincipal" *ngIf="correcto == true">
            <div class="ribbon ng-scope" >
                <span class="ng-binding {{colorEstado}}" style="background:none;"
                    title="{{descripcionEstado}}">{{descripcionEstado}}</span>
            </div>
            <div class="row">
                <div class="col-md-12">
                    <app-adjuntar-archivos
                        [adjuntarArchivo]="adjuntarArchivo"
                        [categoria]="categoriaAdjuntarArchivo"
                    ></app-adjuntar-archivos>
                    <app-historico-estados
                        [settings]="configHistoricoEstado"
                    ></app-historico-estados>
                </div>
            </div>
            <hr class="mr-1 ml-1 mt-1 mb-1">
            <div class="row">
                <div class="col-md-12">
                    
                    <div class="row">
                        <div class="col-md-12">
                            <h2 class="text-dark text-center">
                                {{nombreEmpresa}}
                            </h2>
                            <h5 class="text-dark text-center">
                                {{esCitaMedica == true?'Cita médica': 'Cita agenda'}} {{(infoCita.consecutivoPrefijoAct?.length >0 ? infoCita.consecutivoPrefijoAct: '')}}
                            </h5>
                        </div>
                    </div>
                    <hr class="mr-3 ml-3 mt-1 mb-1">
                    <div class="row">
                        <div class="col-md-12">
                            <div class="row">
                                <div class="col-md-12">
                                    <div class="form-horizontal">
                                        <div class="form-group">
                                            <label class="control-label font-weight-bold col-md-4">
                                                {{esCitaMedica == true?'Servicio': 'Asunto'}}
                                            </label>
                                            <div class="col-md-8">
                                                <p>
                                                    {{infoCita.asunto}}
                                                </p>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <hr class="mr-1 ml-1">
                            <div class="row">
                                <div class="col-md-6">
                                    <div class="form-horizontal">
                                        <div class="form-group">
                                            <label class="control-label font-weight-bold col-md-4">
                                                Fecha
                                            </label>
                                            <div class="col-md-8">
                                                <p>
                                                    {{ infoCita.fechaInicio | date: 'dd/MM/yyyy HH:mm' }}
                                                </p>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div class="col-md-6">
                                    <div class="form-horizontal">
                                        <div class="form-group">
                                            <label class="control-label font-weight-bold col-md-4">
                                                Duración
                                            </label>
                                            <div class="col-md-8">
                                                <p>
                                                    {{infoCita.duracion}}
                                                </p>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class="row">
                                <div class="col-md-6">
                                    <div class="form-horizontal">
                                        <div class="form-group">
                                            <label class="control-label font-weight-bold col-md-4">
                                                {{esCitaMedica == true?'Paciente': 'Cliente'}}
                                            </label>
                                            <div class="col-md-8">
                                                <p>
                                                    {{infoCita.nombreTercero}}
                                                </p>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div class="col-md-6">
                                    <div class="form-horizontal">
                                        <div class="form-group">
                                            <label class="control-label font-weight-bold col-md-4">
                                                {{esCitaMedica == true?'Convoca': 'contacto'}}
                                            </label>
                                            <div class="col-md-8">
                                                <p>
                                                    {{infoCita.nombreContacto}}
                                                </p>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class="row">
                                <div class="col-md-6">
                                    <div class="form-horizontal">
                                        <div class="form-group">
                                            <label class="control-label font-weight-bold col-md-4">
                                                Ubicacion
                                            </label>
                                            <div class="col-md-8">
                                                <p>
                                                    {{infoCita.ubicacion}}
                                                </p>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div class="col-md-12">
                                    <div class="form-horizontal">
                                        <div class="form-group">
                                            <label class="control-label font-weight-bold col-md-4">
                                                Participantes
                                            </label>
                                            <div class="col-md-12">
                                                <span *ngFor="let item of participantes" class="bg-info m-1 mb-1 text-white p-2 rounded">
                                                    {{item.nombre}}
                                                </span>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            
                        </div>
                    </div>
                    <br>
                    <div class="row">
                        <div class="col-md-12 d-flex justify-content-center">
                            <button *ngIf="verBtnConfirmar == true" type="button" class="mr-sm-3 mb-1 btn btnEstado {{infoCita.colorEstadoConfirmar?.length > 0?infoCita.colorEstadoConfirmar : 'btn-success' }}" (click)="cambiarEstado(infoCita?.idEstadoConfirmar)">
                                {{infoCita.desEstadoConfirmar?.length > 0 ? infoCita.desEstadoConfirmar : 'Confirmar'}}
                            </button>
                            <button *ngIf="verBtnCancelar == true" type="button" class="mb-1 btn btnEstado {{infoCita.colorEstadoCancelar?.length > 0?infoCita.colorEstadoCancelar : 'btn-danger' }}" (click)="cambiarEstado(infoCita?.idEstadoCancelar)">
                                {{infoCita.desEstadoCancelar?.length > 0 ? infoCita.desEstadoCancelar : 'Cancelar'}}
                            </button>
                            <button *ngIf="verBtnReprogramar == true" type="button" class="ml-sm-3  mb-1 btn btnEstado {{infoCita.colorEstadoReprogramar?.length > 0? infoCita.colorEstadoReprogramar : 'btn-info' }}" (click)="cambiarEstado(infoCita?.idEstadoReprogramar)">
                                {{infoCita.desEstadoReprogramar?.length > 0 ? infoCita.desEstadoReprogramar : 'Reprogramar'}}
                            </button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="cajaPrincipal" *ngIf="correcto != true">
            <div class="row">
                <div class="col-md-12">
                    <div class="col-md-12">
                        <h3>
                            {{notificacionTitulo}}
                        </h3>
                        <hr>
                        <p>
                          {{notificacionMensaje}}
                        </p>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>